import cls from "./LinksPage.module.scss"
import linkedIn from "shared/assets/icons/LinkedIn-logo.webp"
import telegram from "shared/assets/icons/telegram-logo.png"
import vk from "shared/assets/icons/vk-logo.png"
import habr from "shared/assets/icons/habr-logo.png"
import mail from "shared/assets/icons/mail-logo.jpg"

export const LinksPage = () => {

    const onRedirect = (url: string) => {
        window.open(url)
    }

    return (
        <div className={cls.LinksPage}>
            <div className={cls.title}>Свяжитесь со мной</div>
            <div className={cls.secondText}>любым удобным для вас способом:</div>
            <div className={cls.container}>
                <div onClick={() => onRedirect('https://www.linkedin.com/in/matvey770/')} className={cls.item}>
                    <div className={cls.name}>LinkedIn</div>
                    <img className={cls.icon} src={linkedIn} alt="icon"></img>
                </div>
                <div onClick={() => onRedirect('https://t.me/Freeze771')} className={cls.item}>
                    <div className={cls.name}>Telegram</div>
                    <img className={cls.icon} src={telegram} alt="icon"></img>
                </div>
                <div onClick={() => onRedirect('https://vk.com/fre_eze')} className={cls.item}>
                    <div className={cls.name}>VK</div>
                    <img className={cls.icon} src={vk} alt="icon"></img>
                </div>
                <div onClick={() => onRedirect('https://career.habr.com/matvey770')} className={cls.item}>
                    <div className={cls.name}>Habr</div>
                    <img className={cls.icon} src={habr} alt="icon"></img>
                </div>
                <a className={cls.item} href="mailto:smirnv.matvejj@yandex.ru">
                    <div className={cls.name}>E-mail</div>
                    <img className={cls.icon} src={mail} alt="icon"></img>
                </a>
            </div>
        </div>
    )
}